export enum BackupRoutesEnum {
  Overview = 'overview',
  Uploads = 'uploads',
  Reports = 'reports',
  Settings = 'settings',
}
